var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExpandTransition',[(_vm.errors[0])?_c('div',{staticClass:"errors",style:({
      color: _vm.theme.errorsColor
    })},[_vm._v(" "+_vm._s(_vm.errors[0])+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }